import { useState } from "react";
import { useAuthActions } from "@convex-dev/auth/react";

// Operator login via @convex-dev/auth Password provider (convex/auth.ts uses
// convexAuth({ providers: [Password] })). The Password provider reads the
// "flow" form field ("signIn" | "signUp") plus email/password. The first
// operator signs up; afterwards it is sign-in only. TODO(phase1): disable
// open sign-up once the operator account exists (invite-only).
export function SignIn() {
  const { signIn } = useAuthActions();
  const [flow, setFlow] = useState<"signIn" | "signUp">("signIn");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const form = new FormData(e.currentTarget);
    form.set("flow", flow);
    try {
      await signIn("password", form);
    } catch (err) {
      setError(
        flow === "signIn"
          ? "Sign-in failed — check your email and password."
          : "Sign-up failed — the account may already exist.",
      );
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="signin-wrap">
      <form className="signin-card" onSubmit={onSubmit}>
        <div className="signin-brand">
          <span className="brand-mark">◆</span> KinSafe Fleet
        </div>
        <h1 className="signin-title">Operator console</h1>
        <p className="signin-sub">
          Control plane only. No customer content is reachable from here.
        </p>

        <label className="field">
          <span>Email</span>
          <input
            name="email"
            type="email"
            autoComplete="email"
            required
            placeholder="operator@kinsafe.ai"
          />
        </label>
        <label className="field">
          <span>Password</span>
          <input
            name="password"
            type="password"
            autoComplete={
              flow === "signIn" ? "current-password" : "new-password"
            }
            required
            placeholder="••••••••••"
          />
        </label>

        {error && <div className="signin-error">{error}</div>}

        <button className="btn btn-primary" type="submit" disabled={submitting}>
          {submitting
            ? "…"
            : flow === "signIn"
              ? "Sign in"
              : "Create operator account"}
        </button>

        <button
          type="button"
          className="btn btn-link"
          onClick={() => {
            setError(null);
            setFlow(flow === "signIn" ? "signUp" : "signIn");
          }}
        >
          {flow === "signIn"
            ? "First-time setup? Create the operator account"
            : "Have an account? Sign in"}
        </button>
      </form>
    </div>
  );
}
